export class ListQueryExecutionsRequestFiltersId {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequestFiltersId.attributeTypeMap;
    }
    constructor() {
    }
}
